import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable({
  providedIn: 'root',
})
export class ManageScenarioWorkflowDataGridService {
  manageScenarioWorkFlowPayload: any;
  event: any;
  isPublic: any;
  Access: any;

  constructor(private swalService: SwalService, private accessService: AccessPermissionService) {}
  accessAllPermission() {
    const access = this.isAccess('edit') || this.isAccess('delete');
    return access;
  }
  editScenarioWorkFlowData = new Subject<[any, any]>();
  ScenarioWorkFlowEditObservable$ = this.editScenarioWorkFlowData.asObservable();
  deleteScenarioWorkFlowData = new Subject<[any, any, any]>();
  ScenarioWorkFlowDeleteObservable$ = this.deleteScenarioWorkFlowData.asObservable();

  getManageScenarioWorkFlowDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'position',
      headerName: 'position',
      field: 'position',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Label',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        const checkAccess = this.isAccess('edit') || this.isAccess('view');
        if (checkAccess && !params.data.isSystem) {
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess &&
            !params.data.isSystem &&
            this.editScenarioWorkFlowData.next([
              params.data.scenarioStatusId,
              'Review scenario status detail',
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Public',
      headerName: 'Public',
      field: 'isPublic',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      valueFormatter: (params: any) => (params.data.isPublic == true ? 'Yes' : 'No'),
    });

    this.accessAllPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        minWidth: grid_widths_map.sm_column_xxm,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: this.isAccess('edit'),
          showDelete: this.isAccess('delete'),
          value: 'manageScenarioWorkFlow',
          deleteData: (data: any, customName: any) => {
            this.deletescenarioWorkFlowConfirmation(
              data.scenarioStatusId,
              '/MyOrganizationManageScenarioWorkflow/DeleteMyOrganizationScenarioWorkFlow?id',
              customName
            );
          },
          editData: (data: any) => {
            this.editScenarioWorkFlowData.next([
              data.scenarioStatusId,
              'Review scenario status detail',
            ]);
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  isAccess = (type: 'view' | 'edit' | 'create' | 'delete') => {
    return this.accessService.hasModulePermission(
      rolesModuleName.myOrganizationScenarioWorkFlow,
      mainModuleName.myOrganizationModule,
      type
    );
  };

  deletescenarioWorkFlowConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteScenarioWorkFlowData.next([data, customType, pathName]);
      } else {
      }
    });
  }
  getManageScenarioWorkFlowPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getManageScenarioWorkFlowDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.manageScenarioWorkFlowPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'position',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
